'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pubnubForcedLeave = pubnubForcedLeave;

var _helpers = require('conversations-core/utils/helpers');

function pubnubForcedLeave(subscribeKey, channel, uuid) {
  var url = 'https://pubsub.pubnub.com/v2/presence/sub-key/' + subscribeKey + '/channel/' + channel + '/leave?uuid=' + uuid;
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url);
  } else {
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.send(null);
    (0, _helpers.sleepBeforeProceeding)();
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/PubNubClient.js
// module id = 479
// module chunks = 0